export default __webpack_public_path__ + "static/media/feature-right-mobile-AU.52c02d66.png";